import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  style: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
};

const defaultProps = {
  style: {},
  width: '18',
  height: '18',
};

const Stores = ({ style, width, height }) => {
  const defaultStyle = {
    fill: 'currentColor',
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
    >
      <path
        {...defaultStyle}
        {...style}
        fillRule="evenodd"
        d="M9 12c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m8.625-4.5h-2.141c-.15-.592-.34-1.25-.584-1.749l1.524-1.524a.374.374 0 0 0 0-.53l-2.121-2.12a.373.373 0 0 0-.53 0L12.247 3.1c-.5-.243-1.156-.434-1.748-.583V.375A.375.375 0 0 0 10.125 0h-2.25A.375.375 0 0 0 7.5.375v2.142c-.593.15-1.25.34-1.748.583L4.227 1.577a.373.373 0 0 0-.53 0l-2.122 2.12a.375.375 0 0 0 0 .53L3.1 5.752c-.242.496-.434 1.155-.584 1.748H.375A.375.375 0 0 0 0 7.875v2.25c0 .207.168.375.375.375h2.141c.15.593.342 1.251.584 1.748l-1.525 1.526a.373.373 0 0 0 0 .53l2.122 2.12c.14.141.39.141.53 0L5.752 14.9c.496.242 1.155.433 1.748.584v2.141c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.141c.593-.151 1.251-.342 1.748-.584l1.525 1.524a.374.374 0 0 0 .53 0l2.121-2.12a.373.373 0 0 0 0-.53L14.9 12.248c.242-.497.434-1.155.584-1.748h2.141a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375"
      />
    </svg>
  );
};

Stores.propTypes = propTypes;
Stores.defaultProps = defaultProps;

export default Stores;



// WEBPACK FOOTER //
// ../ui-components/components/MenuItemIcon/Stores.jsx